<template>
	<el-config-provider :value-on-clear="() => null" :locale="lang">
		<router-view></router-view>
		<ReDialog />
		<ReDrawer />
	</el-config-provider>
</template>
<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useConfig } from '@/store/config'
// import { setTitleFromRoute, setTitle } from '/@/utils/common'
import iconfontInit from '/@/utils/iconfont'
import { init as viteInit } from '/@/utils/vite'
import { i18n } from '/@/lang'
import { ReDialog } from '/@/components/ReDialog'
import { ReDrawer } from '/@/components/ReDrawer'
const { t } = i18n.global
// modules import mark, Please do not remove.

const route = useRoute()
const config = useConfig()

// 设置 meta 标签的工具函数
const setMeta = (name: string, content: string) => {
	let meta = document.querySelector(`meta[name="${name}"]`)
	if (!meta) {
		meta = document.createElement('meta')
		meta.setAttribute('name', name)
		document.head.appendChild(meta)
	}
	meta.setAttribute('content', content)
}

// 初始化 element 的语言包
const { getLocaleMessage } = useI18n()
const lang = getLocaleMessage(config.lang.defaultLang) as any
onMounted(async () => {
	viteInit()
	iconfontInit()
})

// 监听路由变化时更新浏览器标题
watch(
	() => route.path,
	() => {
		// console.log(2)
		// setTitleFromRoute()
	}
)
</script>
